import React from 'react';
import {Badge, Table} from "antd";
import {useTeamCandidateScope} from "./TeamCandidateScopeProvider";
import ColorTag from "../../../components/ColorTag";

const TeamPhaseDeliverableTable = ({forAgency, record, canCustomize = true,...props}) => {


    const {
        isDisabled,
        isLoading,
        onEditTeamDeliverable,
        project
    } = useTeamCandidateScope();


    const deliverableColumns = [
        {
            title: 'Deliverable',
            dataIndex: 'name',
            inputType: 'text',
            fixed: 'left',
            width: 150,
            editable: (record) => {
                return !record.is_custom
            },
            render: (_, record) => {
                return (
                    <p className="text-xs">{record.name}</p>
                )
            }
        },
        forAgency ? {
            title: 'Assumptions',
            dataIndex: 'assumptions',
            editable: true,
            inputType: 'editor',
            width: 230,
            render:(_, record) => {
                return (
                    <div className="relative">
                        <div dangerouslySetInnerHTML={{__html: record.assumptions || '<i>No Assumptions Provided</i>'}} className="text-xs line-clamp-3 overflow-ellipsis"/>
                    </div>
                )
            }
        } :
        {
            title: 'Client Feedback',
            dataIndex: 'is_desired',
            // hideOnEdit: true,
            width: 230,
            editable: false,
            render: (_, record) => {
                let color;

                let label;
                switch (record.is_desired) {
                    case true:
                        color = TB.config('color.success-dark');
                        label = 'Yes';
                        break;
                    case false:
                        color = TB.config('color.danger-dark');
                        label = 'No';
                        break;
                    case null:
                        color = '#b7b7b7';
                        label = 'Unsure';
                        break;
                }
                if (record.is_custom) {
                    color = TB.config('color.warning-dark');
                    label = 'Custom';
                }

                return (
                    <div className="flex flex-col gap-4">
                        <div className="flex flex-row items-center gap-2">
                            <p className="text-xs font-semibold underline">
                                Desired?
                            </p>
                            <Badge count={label} showZero color={color}/>
                        </div>
                        <div className="w-full flex flex-col items-start relative">
                            <div className="relative">
                                <p className="text-xs line-clamp-3 overflow-ellipsis">{record.client_comments || (
                                    <i>No Addition Notes Provided</i>)}</p>
                            </div>
                        </div>
                    </div>
                )
            }
        },
        // {
        //     title: 'Talent Notes',
        //     dataIndex: 'notes_to_talent',
        //     inputType: 'editor',
        //     width: 260,
        //     editable: true,
        //     render: (_, record) => {
        //         return (
        //             <div className="relative">
        //                 <p className="text-xs line-clamp-3 overflow-ellipsis"
        //                    dangerouslySetInnerHTML={{__html: (record.notes_to_talent || '<i>No Notes Given</i>')}}/>
        //             </div>
        //         )
        //     }
        // },
        {
            title: 'Roles Used',
            dataIndex: 'disciplines',
            width: 260,
            render: (_, record) => {
                let deliverableDisciplines = TB.uniqBy(TB.flatMap(record.activities, 'disciplines'), 'id')
                return (
                    <div className="flex flex-row flex-wrap gap-3 items-center">
                        {TB.map(deliverableDisciplines || [], discipline => (
                            <ColorTag
                                key={`rec-${record.id}-dis-${discipline.id}`}
                                label={discipline.name}
                                closable={false}/>
                        ))}
                    </div>
                )
            }
        },
        {
            title: 'Scoped Hours',
            dataIndex: 'total_hours',
            // hideOnEdit: true,
            inputType: 'number',
            width: 90,
            editable: false,
            render: (_, record) => {
                return (
                    <p className={TB.mapClass("text-xs", {"line-through opacity-60 text-danger": !record.is_active})}>
                        {record.total_hours || '-'}
                    </p>
                )
            }
        },
        {
            title: 'Scoped Cost',
            dataIndex: 'estimated_cost',
            // hideOnEdit: true,
            width: 90,
            editable: false,
            render: (_, record) => {
                return (
                    <p className={TB.mapClass("text-xs", {"line-through opacity-60 text-danger": !record.is_active})}>
                        {record.estimated_cost ? TB.formatCurrency(record.estimated_cost) : '-'}
                    </p>
                )
            }
        },
        {
            title: 'Team Hours',
            dataIndex: 'total_team_hours',
            // hideOnEdit: true,
            inputType: 'number',
            width: 90,
            editable: false,
            render: (_, record) => {
                return (
                    <p className="font-medium">
                        {record.total_team_hours || '-'}
                    </p>
                )
            }
        },
        {
            title: 'Team Est Payout',
            dataIndex: 'estimated_team_cost',
            // hideOnEdit: true,
            width: 100,
            editable: false,
            render: (_, record) => {
                return (
                    <p className="font-medium">
                        {record.estimated_team_cost ? TB.formatCurrency(record.estimated_team_cost) : '-'}
                    </p>
                )
            }
        },
        // {
        //     title: 'Team Est Cost',
        //     dataIndex: 'estimated_platform_cost',
        //     // hideOnEdit: true,
        //     width: 75,
        //     editable: false,
        //     render: (_, record) => {
        //         return (
        //             <p className="font-medium">
        //                 {TB.formatCurrency(record.estimated_platform_cost)}
        //             </p>
        //         )
        //     }
        // },
        {
            title: 'Actions',
            dataIndex: 'operation',
            width: 100,
            render: (_, record) => {

                // const editable = isEditing(record);
                return (
                    <button className="btn btn-link btn-link-primary" disabled={isDisabled}
                            onClick={() => onEditTeamDeliverable(record)}>
                        Edit
                    </button>
                )
            },
        },
    ]

    return (
        <div className="scope-inner-table">
            <div>
                <Table
                    rowKey="display_index"
                    // expandable={{
                    //     expandedRowRender: deliverableRecord => <TeamDeliverableActivitiesTable canCustomize={false} record={deliverableRecord}/>,
                    //     // defaultExpandAllRows: false
                    // }}
                    columns={deliverableColumns}
                    dataSource={record.deliverables}
                    bordered
                    size="middle"
                    pagination={false}/>

            </div>
        </div>
    );
};

export default TeamPhaseDeliverableTable;